import React, { useState } from 'react';
import './App.css';
import Sidebar from './components/Sidebar';
import SearchTypeSelection from './components/SearchTypeSelection';
import SearchInput from './components/SearchInput';
import SearchResults from './components/SearchResults';
import { osintTools } from './config/osintTools';

function App() {
  const [currentView, setCurrentView] = useState('home');
  const [currentStep, setCurrentStep] = useState(1);
  const [searchType, setSearchType] = useState('username');
  const [searchTerm, setSearchTerm] = useState('');

  const totalPlatforms = Object.values(osintTools).reduce(
    (sum, tools) => sum + tools.length,
    0
  );

  const handleSelectType = (type) => {
    setSearchType(type);
    setCurrentStep(2);
  };

  const handleSearch = (term) => {
    setSearchTerm(term);
    setCurrentStep(3);
  };

  const handleNewSearch = () => {
    setCurrentStep(2);
  };

  const handleNavigate = (view) => {
    if (view === 'home') {
      setCurrentView('home');
      setCurrentStep(1);
    } else {
      setCurrentView(view);
    }
  };

  return (
    <div className="h-screen bg-gradient-to-br from-[#0f0c29] via-[#302b63] to-[#24243e] text-white flex">
      <Sidebar
        onNavigate={handleNavigate}
        onSearchTypeSelect={handleSelectType}
        totalPlatforms={totalPlatforms}
      />

      <main className="flex-1 flex items-center justify-center p-6">
        {currentView === 'home' && currentStep === 1 && (
          <SearchTypeSelection onSelectType={handleSelectType} />
        )}

        {currentView === 'home' && currentStep === 2 && (
          <SearchInput
            searchType={searchType}
            onBack={() => setCurrentStep(1)}
            onSearch={handleSearch}
          />
        )}

        {currentView === 'home' && currentStep === 3 && (
          <SearchResults
            searchTerm={searchTerm}
            searchType={searchType}
            onNewSearch={handleNewSearch}
          />
        )}
      </main>
    </div>
  );
}

export default App;
